import { ReactNode } from "react";

export enum SWITCH_SIZES {
  LARGE = "large",
  MEDIUM = "medium",
  SMALL = "small",
}

export interface SwitchLabelProps {
  label: string | ReactNode;
  textClass: string;
  labelClassName: string;
}

export interface SwitchToggleProps {
  dimensions: SwitchDimensions;
  circlePosition: number;
  containerClassName: string;
  circleClassName: string;
  onClick: () => void;
}

export interface SwitchProps {
  label?: string | ReactNode;
  checked: boolean;
  onClick: () => void;
  size?: SWITCH_SIZES;
  disabled?: boolean;
}

export interface SwitchDimensions {
  width: number;
  height: number;
  circleSize: number;
}

export interface SwitchSizeConfig {
  width: number;
  height: number;
  textClass: string;
}
